<template>
  <div class="pt20">
    <div class="design_box_out">
      <!-- <p class="design_box_out_title"><i class="iconfont iconyou"></i>{{property.label}}</p> -->
      <!--<div class="tool_company">-->
        <!-- <div class="company-desc design_box">
          {{property.body}}
        </div> -->
      <!--</div>-->
		<!-- <div class="demo-input-suffix">
			<el-input
			  placeholder="请输入内容"
			  v-model="input4">
			  <i slot="prefix" class="el-input__icon el-icon-search"></i>
			</el-input>
		</div>
		<div class="display">
			<div class="name">
				<div class="marginTop10" style="display: flex;">丽园蛋糕房<div class="update" v-if="property.updates==1">上新</div></div>
				<div class="font12 marginTop10">{{property.textareas}}</div>
				当日新鲜出炉，保证新鲜
			</div>
			<div class="marginLeft5">
				<img src="@/assets/imgs/share1.png"></img>
			</div>
		</div>
		<div class="display marginTop30 cumulativeBox">
			<div class="grandTotal">累计访问{{property.visits}}</div>
			<div class="grandTotal">累计出售{{property.sales}}</div>
			<div class="img" v-if="property.enterprises==1"><img src="@/assets/imgs/defultbg2@3x.png" alt=""><p>认证企业</p></div>
		</div> -->
		<div class="ShopTemplate" v-if="property.radios==1">
			<!-- <el-radio v-model="radio" label="1">样式一</el-radio> -->
			<el-form ref="form" label-width="80px" style="background-color: bisque;">
				<div class="demo-input-suffix" style="width: 55%;">
					<el-input
					  placeholder="请输入内容"
					  suffix-icon="el-icon-search"
					  v-model="input5">
					  <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
					</el-input>
				</div>
				<div class="display">
					<div class="name">
						<div class="marginTop10" style="display: flex;font-size: 24px;">丽园蛋糕房<div class="update" v-if="property.updates==1">上新</div></div>
						<div class="font12 marginTop10">{{property.textareas}}</div>
						<!-- 当日新鲜出炉，保证新鲜 -->
					</div>
					<div class="marginLeft5">
						<img src="@/assets/imgs/share1.png"></img>
					</div>
				</div>
				<div class="display marginTop30 cumulativeBox">
					<div class="grandTotal">累计访问{{property.visits}}</div>
					<div class="grandTotal">累计出售{{property.sales}}</div>
					<!-- <div class="img" v-if="property.enterprises==1"><img src="@/assets/imgs/defultbg2@3x.png" alt=""><p>认证企业</p></div> -->
					<div class="img" v-if="property.enterprises==1"><img src="@/assets/imgs/Authentication.png" alt=""></div>
				</div>
			</el-form>
		</div>
		<div class="ShopTemplate" v-if="property.radios==2">
			<!-- <el-radio v-model="radio" label="2">样式二</el-radio> -->
			<div class="topBox">
				<el-form ref="form" label-width="80px">
					<div class="display">
						<div class="name">
							<div class="marginTop10 font20" style="display: flex;">丽园蛋糕房<div class="img" v-if="property.enterprises==1"><img src="@/assets/imgs/Authentication.png" alt=""></div></div>
							<!-- <div class="font12 marginTop10 marginBottom10">{{property.textareas}}</div> -->
							<!-- 当日新鲜出炉，保证新鲜 -->
							<div class="display cumulativeBox" style="padding: 0px 0px 15px;">
								<div class="grandTotal">累计访问{{property.visits}}</div>
								<div class="grandTotal">累计出售{{property.sales}}</div>
							</div>
						</div>
					</div>
					<div class="demo-input-suffix" style="width: 90%;">
						<el-input
						  placeholder="请输入内容"
						  style="width: 100%;"
						  suffix-icon="el-icon-search"
						  v-model="input6">
						  <!-- <i slot="prefix" class="el-input__icon el-icon-search aaa"></i> -->
						</el-input>
					</div>
					
				</el-form>
			</div>
			
			<div class="imageBox">
				<img :src="property.pic[0]" alt="">
			</div>
		</div>
		<div class="ShopTemplate" v-if="property.radios==3">
			<!-- <el-radio v-model="radio" label="3">样式三</el-radio> -->
			<el-form ref="form" label-width="80px" style="background-color: bisque;">
				<div style="display: flex;">
					<div style="z-index: 999;">
						<img class="image" src="@/assets/imgs/bitmap.png"></img>
					</div>
					<div class="demo-input-suffix" style="width: 75%;">
						<el-input
						  placeholder="请输入内容"
						  v-model="input7"
						  suffix-icon="el-icon-search"
						  style="margin-left: -10px;">
						  <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
						</el-input>
					</div>
				</div>
				
				<div class="display">
					<div class="name">
						<div class="marginTop10" style="display: flex;">丽园蛋糕房<div class="update" v-if="property.updates==1">上新</div></div>
						<div class="font12 marginTop10">{{property.textareas}}</div>
						<!-- 当日新鲜出炉，保证新鲜 -->
						
					</div>
					<div class="marginLeft5" style="margin-top: 30px;">
						<div class="img" v-if="property.enterprises==1"><img src="@/assets/imgs/Authentication.png" alt=""></div>
					</div>
				</div>
			</el-form>
		</div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ["property"],
    data() {
      return {
		  input4: '',
		  input5: '',
		  input6: '',
		  input7: '',
        form: {}
      };
    },
    created() {
		this.input5 = this.property.search_goods_name
		this.input6 = this.property.search_goods_name
		this.input7 = this.property.search_goods_name
		console.log(this.property,"this.property22===========")
    }
  };
</script>

<style>
	.el-input--prefix .el-input__inner {
	    padding-left: 10px;
		border-radius: 30px;
	}
	.el-input__icon {
	    margin-top: 0px;
		position: relative;
		/* left: 200px; */
	    /* margin-left: 140px; */
		line-height: 0px;
	}
	.name{
		width: 80%;
		padding-left: 20px;
	}
	.update{
		width: 43px;
		height: 17px;
		font-size: 10px;
		margin-top: 5px;
		/* border: 1px solid black; */
		border-bottom-right-radius: 20px;
		border-top-left-radius: 15px;
		border-top-right-radius: 20px;
		background-color: darkorange;
		color: white;
	}
	.display{
		display: flex;
	}
	.cumulativeBox{
		font-size: 12px;
		line-height: 25px;
		padding: 0px 20px;
	}
	.grandTotal{
		/* margin-right: 15px; */
		width: 40%;
	}
	.marginLeft5{
		/* margin-left: 5px; */
		margin-right: 15px;
	}
	.img{
		width: 67px;
		height: 22px;
		display: flex;
		/* margin-left: 55px; */
		/* color: forestgreen;
		border: 1px solid forestgreen;
		font-size: 12px; */
	}
	.topBox{
		width: 100%;
		height: 145px;
		border: 1px solid black;
		border-bottom-left-radius: 20px;
		border-bottom-right-radius: 20px;
		background-color: bisque;
	}
	.img >img{
		width: 100%;
	}
</style>

